export default "<app-loader-mask [show]=\"showLoading\"></app-loader-mask>\n<vp-branding></vp-branding>\n<router-outlet></router-outlet>\n";